<script lang="ts">
    import Link from "svelte-link";
    import { Col,Image, Row } from "sveltestrap";
    import { href } from "../../../../utils/Constant/Constant";
    import InvoiceHeaderSub from "./InvoiceHeaderSub.svelte";
    let imgPath:string = "/assets/images/logo"
</script>
<Row class="invo-header"> 
    <Col sm="6">
        <div class="media">
            <div class="media-left">
                <Link href={href}>
                    <Image class="media-object img-60" src="{imgPath}/logo-1.png" />
                </Link>
            </div>
            <div class="media-body m-l-20">
                <h4 class="media-heading">{'Viho'}</h4>
                <p>{'hello@Cuba.in'}<br><span class="digits">{'289-335-6503'}</span></p>
            </div>
        </div>
    </Col>
    <InvoiceHeaderSub />
</Row>